
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/excavation-and-structural-construction-sydney",
      function () {
        return require("private-next-pages/services/excavation-and-structural-construction-sydney/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/excavation-and-structural-construction-sydney"])
      });
    }
  